import { render, staticRenderFns } from "./travelExpensesModal.vue?vue&type=template&id=06a7488d&scoped=true&"
import script from "./travelExpensesModal.vue?vue&type=script&lang=js&"
export * from "./travelExpensesModal.vue?vue&type=script&lang=js&"
import style0 from "./travelExpensesModal.vue?vue&type=style&index=0&id=06a7488d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a7488d",
  null
  
)

export default component.exports